import { render } from "./ButtonContentSwitcher.vue?vue&type=template&id=0d6ec64e&scoped=true&ts=true"
import script from "./ButtonContentSwitcher.ts?vue&type=script&lang=ts&external"
export * from "./ButtonContentSwitcher.ts?vue&type=script&lang=ts&external"

import "./ButtonContentSwitcher.scss?vue&type=style&index=0&id=0d6ec64e&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6ec64e"]])

export default __exports__